import { useEffect, useRef } from 'react'
import { useThree } from '@react-three/fiber'
import { Vector3 } from 'three'

const CustomCamera = function (props: any) {
  const cameraRef = useRef<THREE.PerspectiveCamera>(null)
  const { set, size } = useThree()
  useEffect(() => {
    if (cameraRef.current) {
      cameraRef.current.aspect = size.width / size.height
      cameraRef.current.up.set(0, 1, 0)
      const target = Array.isArray(props.target)
        ? new Vector3(props.target[0], props.target[1], props.target[2])
        : props.target instanceof Vector3
        ? props.target
        : new Vector3(0, 0, 0)
      cameraRef.current.lookAt(target)
      cameraRef.current.updateProjectionMatrix()
    }
  }, [size, props])

  useEffect(() => {
    //@ts-ignore
    set(() => ({ camera: cameraRef.current }))
  }, [set])

  return <perspectiveCamera ref={cameraRef} {...props} />
}

export default CustomCamera
